import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // ✅ SAME firebase instance

export default function DeleteAccount() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      setLoading(true);
      setError("");

      await addDoc(collection(db, "accountDeletionRequests"), {
        email,
        status: "pending",
        requestedAt: serverTimestamp(),
      });

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>Delete Account</h1>

        {!submitted ? (
          <>
            <p style={styles.text}>
              Enter the email associated with your Timeline account.
              We will send a confirmation email to that address. Once you confirm, your account will be permanently deleted within 90 days.<br/><br/>
              <i>You can also delete your account from the "Edit profile" section in the app.</i>
            </p>

            <form onSubmit={handleSubmit}>
              <input
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
              />

              <button type="submit" style={styles.button} disabled={loading}>
                {loading ? "Submitting…" : "Request Account Deletion"}
              </button>
            </form>

            {error && <p style={styles.error}>{error}</p>}
          </>
        ) : (
          <div style={styles.successBox}>
            <h3 style={styles.successTitle}>Request received</h3>
            <p style={styles.successText}>
              We’ve received your account deletion request for:
            </p>
            <p style={styles.successEmail}>{email}</p>
           
            <p style={styles.successText}>
            We will send a confirmation email , once confirmed your account and associated data will be permanently deleted
              within
              <strong> 90 days</strong>, unless retention is required by law.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f9fafb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  card: {
    maxWidth: "420px",
    width: "100%",
    background: "#fff",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    marginBottom: "12px",
  },
  text: {
    fontSize: "14px",
    marginBottom: "16px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "14px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    fontWeight: 600,
    cursor: "pointer",
  },
  success: {
    color: "#065f46",
    fontSize: "14px",
  },
  error: {
    color: "#b91c1c",
    fontSize: "13px",
    marginTop: "8px",
  },
  successBox: {
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '14px',
    padding: '20px',
    textAlign: 'center',
  },
  
  successTitle: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '8px',
    color: '#065f46',
  },
  
  successText: {
    fontSize: '14px',
    color: '#065f46',
    lineHeight: 1.2,
    marginBottom: '8px',
  },
  
  successEmail: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#047857',
    marginBottom: '12px',
    wordBreak: 'break-word',
  },
};
